import { apiToSidecarContent } from "~/components/Sidecar/apiToSidecarContent";
import { useSidecarContent } from "~/components/Sidecar/useSidecarContent";
import { useActiveBreakpoint } from "~/lib/client/useActiveBreakpoint";

type UseSidecarProps = {
  postId: string | number;
  preview?: boolean;
};
/** Utility hook that returns props needed for sidecar rendering */
export const useSidecarProps = ({ postId, preview }: UseSidecarProps) => {
  const isDesktopScreen = useActiveBreakpoint("MEDIUM");

  const {
    data: rawBlocks,
    isLoading: isLoadingSidecar,
    isValidating: isValidatingSidecar,
  } = useSidecarContent({ postId });

  const {
    keyTopicsBlock,
    postListBlocks,
    relatedReportBlock,
    sidecarBlocks,
    wysiwygBlocks,
  } = apiToSidecarContent({ preview, rawBlocks });

  return {
    /** if false, show inline versions of specific blocks above */
    showDesktopSidecar: isDesktopScreen,
    isLoadingSidecar,
    isValidatingSidecar,
    sidecarBlocks,
    keyTopicsBlock,
    postListBlocks,
    relatedReportBlock,
    wysiwygBlocks,
  };
};
